<mb-progress-bar class="progress-bar progress-bar--top-fullwidth"></mb-progress-bar>
<div class="search-box">
  <ng-template #searchboxSkeleton>
    <am-searchbox-skeleton></am-searchbox-skeleton>
  </ng-template>

  <div class="search-box__content" *ngIf="(initialData$ | async) as initialData;
    else searchboxSkeleton">
    <ng-container *ngIf="initialData && !(isLanding$ | async) && (context$ | async) as context">
      <ng-container *ngIf="(isMobile$ | async); else desktopSearchbox">
        <am-searchbox-summary [searchboxData]="{ initialData, context }"></am-searchbox-summary>
      </ng-container>

      <ng-template #desktopSearchbox>
        <am-search-box [country]="context?.site" [brand]="context?.brand" [channel]="context?.channel"
          [initialData]="initialData" [product]="'hotels'" [dataType]="'model'"
          [allowDollar]="context?.allowDollar" [disableARS]="context?.disableARS" 
          (modelSearch)="handleSearch($event)">
        </am-search-box>
      </ng-template>
    </ng-container>
  </div> 
</div>
<div class="site-content">
  <router-outlet></router-outlet>
</div>